module.exports = __webpack_public_path__ + "32cc2377fd676f2386d705b3b6870020.woff";